import Header from 'hf/Header';
export const MinifiedHeaderFooter = () => <Header />;

export default MinifiedHeaderFooter;
